<template>
  <ExternalList
      endpoint="/api/v2/subscription-commission-agreements"
      :endpoint-filters="{user_id: user.id}"
      :headlines="headlines"
      :button-column-width="2"
      @show="edit"
      :can-destroy="() => true"
  >
    <template v-slot:default="{ row: subscriptionCommissionAgreement }">
      <td>
        {{ subscriptionCommissionAgreement.attributes.portal_name }}
      </td>

      <td>
        {{ subscriptionCommissionAgreement.attributes.interval_start }} -
        {{ subscriptionCommissionAgreement.attributes.interval_end || '(forever)' }}
      </td>

      <td>
        {{ subscriptionCommissionAgreement.attributes.commission | number }} %
      </td>
    </template>

    <template v-slot:modals="{ load, update }">
      <CreateModal :user="user" @created="load"/>

      <EditModal :subscription-commission-agreement="editing" @updated="update"/>
    </template>
  </ExternalList>
</template>

<script>
import CreateModal from '../Modals/Create'
import EditModal from '../Modals/Edit'
import ExternalList from '../../../Panels/Lists/External'

export default {
  components: {CreateModal, EditModal, ExternalList},

  props: {
    user: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  computed: {
    headlines() {
      return [
        {width: 8, text: 'Portal'},
        {width: 8, text: 'Months'},
        {width: 5, text: 'Commission'}
      ]
    }
  },

  methods: {
    edit(subscriptionCommissionAgreement) {
      this.editing = subscriptionCommissionAgreement

      $('#edit-subscription-commission-agreement-modal').modal('show')
    }
  }
}
</script>
